var _polygon, _polygon2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 124.5 71.7",
    enableBackground: "new 0 0 124.5 71.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "0,45.6 11.4,34.2 11.4,11.4 34.2,11.4 45.6,0 0,0 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "124.5,26.1 113.1,37.5 113.1,60.3 90.3,60.3 78.9,71.7 124.5,71.7 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.7,31.2l1.5-1.8c1,0.8,2.1,1.4,3.4,1.4c1,0,1.6-0.4,1.6-1.1v0c0-0.6-0.4-1-2.3-1.4c-2.3-0.6-3.8-1.2-3.8-3.5v0 c0-2.1,1.7-3.4,4-3.4c1.7,0,3.1,0.5,4.2,1.4l-1.3,1.9c-1-0.7-2-1.1-3-1.1c-1,0-1.5,0.4-1.5,1v0c0,0.7,0.5,1,2.5,1.5 c2.3,0.6,3.6,1.4,3.6,3.4v0c0,2.3-1.7,3.5-4.2,3.5C24.8,33,23.1,32.4,21.7,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9,21.5h2.5v11.4h-2.5V21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2,21.5h2.7l3,4.8l3-4.8h2.7v11.4h-2.5v-7.4l-3.2,4.9h-0.1l-3.2-4.8v7.4h-2.5V21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3,21.5h4.7c2.7,0,4.4,1.6,4.4,3.9v0c0,2.6-2,4-4.6,4h-1.9v3.4h-2.5V21.5z M68.8,27.2c1.3,0,2-0.7,2-1.7v0 c0-1.1-0.8-1.7-2-1.7h-1.9v3.5H68.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,21.5h2.5v9.1h5.7v2.3H79V21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7,28.4l-4.4-6.9h2.9l2.7,4.6l2.8-4.6h2.8l-4.4,6.8v4.5h-2.5V28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9,39.1h8.7v2.3h-6.2v2.4h5.4V46h-5.4v4.4h-2.5V39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8,39.1H40c1.4,0,2.6,0.4,3.3,1.2c0.6,0.6,1,1.5,1,2.6v0c0,1.8-1,3-2.4,3.5l2.8,4.1h-2.9l-2.4-3.6h-2v3.6h-2.5V39.1z  M39.8,44.6c1.2,0,1.9-0.6,1.9-1.6v0c0-1.1-0.7-1.6-2-1.6h-2.5v3.3H39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7,39H55l4.9,11.5h-2.6l-1-2.6h-4.8l-1,2.6h-2.6L52.7,39z M55.3,45.7L53.8,42l-1.5,3.7H55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5,39.1h2.7l3,4.8l3-4.8h2.7v11.4h-2.5V43l-3.2,4.9h-0.1l-3.2-4.8v7.4h-2.5V39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6,39.1h8.6v2.2h-6.1v2.3h5.4v2.2h-5.4v2.4h6.2v2.2h-8.7V39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6,39.1h4.4c3.6,0,6,2.5,6,5.7v0c0,3.2-2.5,5.7-6,5.7h-4.4V39.1z M95.1,41.3v6.9h1.9c2,0,3.4-1.4,3.4-3.4v0 c0-2-1.4-3.4-3.4-3.4H95.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.53585e2ad92bdfafbc049e967a167fb6.svg";
export { ForwardRef as ReactComponent };